/** Translate known public error messages into bounded analytics codes. Never forward free text. */
export function analyticsErrorReason(message: unknown): string {
  if (typeof message !== 'string') return 'unknown';
  const text = message.toLowerCase();
  if (text.includes('room not found')) return 'room_not_found';
  if (text.includes('room is full')) return 'room_full';
  if (text.includes('already started')) return 'game_in_progress';
  if (text.includes('nickname already')) return 'nickname_taken';
  if (text.includes('nickname')) return 'invalid_nickname';
  if (text.includes('reconnect credential')) return 'invalid_credential';
  if (text.includes('invalid room code')) return 'invalid_room_code';
  if (text.includes('too many requests')) return 'rate_limited';
  if (text.includes('at least 3')) return 'not_enough_players';
  if (text.includes('wait for connected')) return 'players_pending';
  if (text.includes('updating') || text.includes('maintenance')) return 'maintenance';
  if (text.includes('failed to fetch') || text.includes('network')) return 'network';
  return 'action_rejected';
}
